import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    height: '5px',
    transformOrigin: '0 0',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.standard,
    }),
  },
  rootColorReviewPurple: {
    backgroundColor: theme.palette.facet.reviewPurple,
  },
  rootColorCompleteGreen: {
    backgroundColor: theme.palette.facet.completeGreen,
  },
});

const Bar = ({
  className,
  classes,
  color,
  transform,
  width,
}) => {
  const rootStyle = {
    width,
    transform,
  };

  return (
    <div
      style={rootStyle}
      className={classNames(classes.root, className, {
        [classes.rootColorReviewPurple]: color === 'reviewPurple',
        [classes.rootColorCompleteGreen]: color === 'completeGreen',
      })}
    />
  );
};

Bar.defaultProps = {
  className: '',
};

Bar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(['reviewPurple', 'completeGreen']).isRequired,
  transform: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

export default withStyles(styles)(Bar);
